import classNames from 'classnames';
import { useLocalization } from '../../custom-hooks/useLocalization';

const OfficeCard = ({
  name,
  cardThumbnailPath,
  cardThumbnailAlt = '',
  addressLine1,
  addressLine2,
  city,
  state,
  postalCode,
  phone,
  fax,
  url,
  isAllianceLocation,
  index
}) => {
  const { resourceStrings } = useLocalization();
  const googleMapsSearchUrl = `https://www.google.com/maps/search/${addressLine1} ${city}, ${state} ${postalCode}`;

  return (
    <li
      className={classNames('office-card', { 'is-alliance-location': isAllianceLocation })}
      key={index}
    >
      <article>
        {cardThumbnailPath &&
          (url ? (
            <a href={url}>
              <img src={cardThumbnailPath} alt={cardThumbnailAlt} />
            </a>
          ) : (
            <img src={cardThumbnailPath} alt={cardThumbnailAlt} />
          ))}
        <div className="content">
          {url ? (
            <a href={url}>
              <h2 className="content-title">{name}</h2>
            </a>
          ) : (
            <h2 className="content-title">{name}</h2>
          )}
          <address>
            <div>
              <span>{addressLine1}</span>
              <br />
              {addressLine2 && (
                <>
                  <span>{addressLine2}</span>
                  <br />
                </>
              )}
              <span>
                {city}, {state} {postalCode}
              </span>
            </div>

            <div>
              <div className="link-with-icon">
                <span className="icon material-icons-outlined" aria-hidden="true">
                  call
                </span>
                <a href={`tel:${phone}`}>{phone}</a>
              </div>
              {fax && (
                <div className="link-with-icon">
                  <span className="icon material-icons-outlined" aria-hidden="true">
                    fax
                  </span>
                  <a href={`tel:${fax}`}>{fax}</a>
                </div>
              )}
              {!isAllianceLocation && (
                <div className="link-with-icon">
                  <span className="icon material-icons-outlined" aria-hidden="true">
                    place
                  </span>
                  <a href={googleMapsSearchUrl} target="_blank" rel="nofollow noopener">
                    {resourceStrings.locationDetailGetDirections}
                  </a>
                </div>
              )}
              {isAllianceLocation && url && (
                <div className="link-with-icon">
                  <span className="icon material-icons-outlined">launch</span>
                  <a href={url} target="_blank" rel="nofollow noopener">
                    {resourceStrings.allianceLocationsLandingCardCTA}
                  </a>
                </div>
              )}
            </div>
          </address>
        </div>
      </article>
    </li>
  );
};

export default OfficeCard;
